import { FC } from 'react';
import useQueryParams from '@common/src/hooks/useQueryParams';
import { useAnvaQuotes } from '@flows/src/api/anva-flows/getAnvaQuotes';
import FlowProductsSidebar, {
  FlowProductsSidebarItem,
} from '@flows/src/components/flow-products/FlowProductsSidebar';
import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import { useFlowProductsOverviewParams } from '@flows/src/hooks/flow-products/useFlowProductsOverviewParams';
import { useHistory } from 'react-router';

const FlowProductsAnvaSidebar: FC = () => {
  const { flowId, insuranceId } = useFlowProductsOverviewParams();
  const history = useHistory();
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || undefined;
  const { data, isLoading } = useAnvaQuotes({
    sessionId,
    queryOptions: {
      enabled: !!sessionId,
    },
  });
  const sideBarItems =
    data?.quotes?.reduce((uniqueItems, { insurance }) => {
      if (!uniqueItems.some((item) => item.key === insurance.id.toString())) {
        uniqueItems.push({
          key: insurance.id.toString(),
          label: insurance.name,
        });
      }
      return uniqueItems;
    }, [] as FlowProductsSidebarItem[]) || [];

  const handleNavigate = (_insuranceId: string) => {
    history.push({
      pathname: `${FLOWS_PRODUCTS_PATH}/${flowId}/overview/${_insuranceId}`,
      search: window.location.search,
    });
  };

  return (
    <FlowProductsSidebar
      items={sideBarItems}
      activeItem={insuranceId || ''}
      onItemClick={handleNavigate}
      isHidden={sideBarItems.length === 0 || isLoading}
    />
  );
};

export default FlowProductsAnvaSidebar;
